// Comparações monetárias em centavos inteiros. Comparar floats direto (ex: 1189.3
// vs 1189.3000000000002) faz um valor igual ao saldo parecer maior que ele e
// obriga o usuário a "ajustar" R$ 0,01.
export const toCents = (value: number): number => Math.round((Number(value) || 0) * 100);

/** `true` somente quando `value` é MAIOR que `limit` na precisão de centavos. */
export const exceedsMoney = (value: number, limit: number): boolean =>
  toCents(value) > toCents(limit);
